import React, { useEffect, useState } from "react";
import useScrollToTop from "../hooks/useScrollToTop";

interface BlogMeta {
  slug: string;
  title: string;
  author: string;
  date: string;
}

import { BlogIndexTile } from "./BlogIndexTile";
import HyperLayout from "./HyperLayout";
import HeroSection from "./HeroSection";

const BlogIndex: React.FC = () => {
  const [posts, setPosts] = useState<BlogMeta[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [founderMode, setFounderMode] = useState(false);

  // Use scroll to top hook
  useScrollToTop();

  useEffect(() => {
    fetch("/blog/blog-index.json")
      .then((res) => {
        if (!res.ok) throw new Error("Blog index not found");
        return res.json();
      })
      .then((data) => {
        // Sort the posts by date (most recent first)
        const sortedPosts = [...data].sort((a, b) => {
          return new Date(b.date).getTime() - new Date(a.date).getTime();
        });
        setPosts(sortedPosts);
      })
      .catch((err) => setError(err.message));
  }, []);

  if (error) return <div style={{ color: "red" }}>{error}</div>;
  if (!posts.length) return <div>Loading...</div>;

  const filteredPosts = founderMode
    ? posts.filter((post) => post.author.toLowerCase().includes("edison"))
    : posts;

  return (
    <HyperLayout hideBanner={true}>
      <HeroSection>
        <div className="max-w-3xl mt-auto mx-auto w-full px-4 md:px-0 pt-16 pb-4">
          <h1 className="text-4xl sm:text-5xl font-semibold text-white leading-tight font-sanstext-center mb-8">
            Blog
          </h1>
          <div className="flex items-center justify-end mb-8">
            <label className="flex items-center gap-3 cursor-pointer select-none">
              <span className="text-base font-medium text-white">
                Founder Mode
              </span>
              <input
                type="checkbox"
                checked={founderMode}
                onChange={(e) => setFounderMode(e.target.checked)}
                className="sr-only"
              />
              <span
                className={`w-10 h-6 flex items-center bg-gray-200 rounded-full p-1 duration-300 ${
                  founderMode ? "bg-primary/80" : ""
                }`}>
                <span
                  className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ${
                    founderMode ? "translate-x-4" : ""
                  }`}></span>
              </span>
            </label>
          </div>
        </div>
      </HeroSection>
      <div className="max-w-3xl w-full mx-auto pb-16 px-4 md:px-0">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-10">
          {filteredPosts?.[0] && (
            <div className="col-span-1 md:col-span-2">
              <BlogIndexTile post={filteredPosts[0]} />
            </div>
          )}
          {filteredPosts?.slice(1, filteredPosts.length - 1).map((post) => (
            <BlogIndexTile key={post.slug} post={post} />
          ))}
        </div>
      </div>
    </HyperLayout>
  );
};

export default BlogIndex;
